function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("path", {
  d: "M-98.3,381.2h-20.4l-6,10.8h32.4L-98.3,381.2z M-126,376.8l-10.4-17.2h-12l16,28L-126,376.8z M-68.3,359.2h-12.4l-10,17.2 l6.4,10.8L-68.3,359.2z M-118.4,372.4h20.4l10-17.6l-10-17.6h-20.4l-10,17.6L-118.4,372.4z M-102.3,344.4l6,10.4l-6,10.4h-12 l-6-10.4l6-10.4H-102.3z M-148.4,350.4h12l10-17.2l-6-10.8L-148.4,350.4z M-90.7,333.2l10,17.2h12.4l-16-28L-90.7,333.2z  M-118.4,328.8h20.4l6-10.8h-32.4L-118.4,328.8z"
});

var _ref3 =
/*#__PURE__*/
React.createElement("path", {
  d: "M-107.4,413.2c-7.5,0-14.7-0.8-21.8-2.5c-6.7-1.7-13.4-3.8-20.1-6.7c5.9,4.2,10.9,8.8,15.9,14.2c4.6,5,8.8,10.9,12.6,17.2 c3.4,6.3,6.3,12.6,8.8,19.7c2.5,6.7,3.8,14.2,4.6,21.4c0.8-7.1,2.1-14.2,4.6-21.4c2.1-7.1,5.4-13.8,8.8-19.7 c3.8-6.3,8-11.7,12.6-17.2c5-5.4,10.1-10.1,15.9-14.2c-6.3,2.9-13,5-20.1,6.7C-92.8,412-99.9,412.8-107.4,413.2z"
});

var SvgSwrpgFailureThreat = function SvgSwrpgFailureThreat(_ref) {
  var svgRef = _ref.svgRef,
      props = _objectWithoutProperties(_ref, ["svgRef"]);

  return React.createElement("svg", _extends({
    id: "Layer_1",
    x: "0px",
    y: "0px",
    viewBox: "-207 299 196 196",
    style: {
      enableBackground: "new -207 299 196 196"
    },
    xmlSpace: "preserve",
    ref: svgRef
  }, props), _ref2, _ref3);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgSwrpgFailureThreat, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/swrpg-failure-threat.7f9c0738.svg";
export { ForwardRef as ReactComponent };